import React from 'react';

/**
 * Grab-tab + X row used by mobile bottom sheets (box tray, shared Modal).
 * The row is the swipe-to-dismiss target; bind the drag handlers here so the
 * gesture never fights scrollable content below.
 */
export default function SheetHandle({
  onClose,
  onDragStart,
  onDragMove,
  onDragEnd,
  closeLabel = 'Close',
  className = '',
}) {
  return (
    <div
      className={`relative flex h-11 flex-shrink-0 touch-none items-center justify-end px-2 short:h-10 ${className}`}
      onTouchStart={onDragStart}
      onTouchMove={onDragMove}
      onTouchEnd={onDragEnd}
      onTouchCancel={onDragEnd}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label={closeLabel}
        className="absolute inset-x-0 inset-y-0 mx-auto my-auto h-1.5 w-10 rounded-full bg-gray-300 transition-colors hover:bg-gray-400"
      />
      <button
        type="button"
        onClick={onClose}
        aria-label={closeLabel}
        className="relative rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
      >
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
